import { cloudAxios } from "../axiosInterface";

export const encryptSessionKey = async ({ brand, store, signatory }) => {
  const result = await cloudAxios.get("api/kyc/emsigner", {
    params: { brand, store, signatory },
  });
  return result.data;
};
